import { isNil } from './isNil'

export const isNilOrEmpty = (value: unknown): value is null | undefined | '' =>
  isNil(value) || value === ''
